import app from '@/app';
import ability from '../permissions/ability';

app.config.globalProperties.$ability = ability;
